import NavigationItem from '../module/navigation/NavigationItem'
import { Text } from '~/components/ui/Text'
import { appConfig } from '~/constants/appConfig'

export default function Footer() {
  return (
    <footer className='flex items-center justify-between h-16 px-4 md:px-10 bg-dark-20 z-10'>
      <div className='flex gap-x-4'>
        <NavigationItem
          href={`${import.meta.env.VITE_NOCTUA_URL}/tou`}
          isExternal
          className='text-sm'>
          Terms of Use
        </NavigationItem>
        <NavigationItem
          href={`${import.meta.env.VITE_NOCTUA_URL}/privacy`}
          isExternal
          className='text-sm'>
          Privacy Policy
        </NavigationItem>
      </div>
      <div className='flex flex-col gap-y-2'>
        <Text size='sm' variant='muted'>
          © 2025 Noctua. All rights reserved.
        </Text>
        <Text size='sm' variant='muted'>
          Version: {appConfig.version}
        </Text>
      </div>
    </footer>
  )
}
